import {createContext, use} from 'react'

/**
 * Whether duplicate detection is on. Only the consumers that run it (the repo app and Projects) provide
 * the `semantic_similarity_duplicate_issue_detection` client flag here; everywhere else it stays off.
 */
export const DuplicateDetectionEnabledContext = createContext(false)

export function useDuplicateDetectionEnabled(): boolean {
  return use(DuplicateDetectionEnabledContext)
}
